import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isSuperAdmin, getCurrentUser, isAccounts } from "../../services/authService";

const AccountsRoute = (props) => {
  const { path, component: Component, render, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!getCurrentUser()) {
          return <Redirect to="/login" />;
        } else if (!isAccounts() && !isSuperAdmin()) {
          return <Redirect to="/unauthorized" />;
        } else {
          return Component ? <Component {...props} /> : render(props);
        }
      }}
    />
  );
};

export default AccountsRoute;
